import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
const makeDot = (color) => ({ title }) => _jsx(Dot, { title: title, color: color });
export const RedDot = makeDot("danger");
export const GreenDot = makeDot("success");
export const BlueDot = makeDot("info");
const Dot = ({ title, color = "danger", }) => (_jsx(FAIcon, { icon: "circle", type: "fas", title: title, className: "text-" + color, style: {
        verticalAlign: "super",
        fontSize: ".5rem",
        marginLeft: 2,
    } }));
export default Dot;
